import { HEADERS_NAMES_SLUG } from 'common/constant'
import AppProvider from 'context/AppProvider'

import Router from './Router'

const req = new XMLHttpRequest()
req.open('GET', location.href, false)
req.send(null)

const companyName = req.getResponseHeader(HEADERS_NAMES_SLUG.company)
const flowName = req.getResponseHeader(HEADERS_NAMES_SLUG.flow)

if (companyName != null && flowName != null) {
  sessionStorage.setItem(HEADERS_NAMES_SLUG.company, companyName)
  sessionStorage.setItem(HEADERS_NAMES_SLUG.flow, flowName)
} else {
  sessionStorage.removeItem(HEADERS_NAMES_SLUG.company)
  sessionStorage.removeItem(HEADERS_NAMES_SLUG.flow)
}

export default function App(): JSX.Element {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  )
}
